module.exports = __webpack_public_path__ + "img/office1.7e536be6.jpeg";